/* Producttabs: wisselt het zichtbare paneel, de "view all"-knop en de track van de omliggende ts-scroller */
if (!customElements.get('ts-product-tabs')) {
    customElements.define('ts-product-tabs', class extends HTMLElement {
        connectedCallback() {
            if (this.initialized) return;
            this.initialized = true;
            this.tabs = [...this.querySelectorAll('[role="tab"]')];
            this.button = this.querySelector('.ts-ptabs__all');

            this.tabs.forEach((tab) => {
                tab.addEventListener('click', () => this.select(tab));
                tab.addEventListener('keydown', (e) => {
                    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                    const i = this.tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
                    const next = this.tabs[(i + this.tabs.length) % this.tabs.length];
                    next.focus();
                    this.select(next);
                });
            });

            /* Theme-editor: geselecteerde tab tonen */
            document.addEventListener('shopify:block:select', (e) => {
                if (this.tabs.includes(e.target)) this.select(e.target);
            });
        }

        select(tab) {
            this.tabs.forEach((t) => {
                const active = t === tab;
                t.classList.toggle('is-active', active);
                t.setAttribute('aria-selected', String(active));
                t.tabIndex = active ? 0 : -1;
                const panel = document.getElementById(t.getAttribute('aria-controls'));
                if (!panel) return;
                panel.hidden = !active;
                const track = panel.querySelector('.ts-ptabs__track');
                track.toggleAttribute('data-ts-track', active);
                if (active) {
                    track.scrollLeft = 0;
                    const scroller = this.closest('ts-scroller');
                    if (scroller && scroller.setTrack) scroller.setTrack(track);
                }
            });

            if (this.button) {
                this.button.href = tab.dataset.url;
                const label = this.button.querySelector('span');
                if (label) label.textContent = tab.dataset.label;
            }
        }
    });
}
